import { useEffect} from "react";
import Matter from "matter-js";
import './spoondrop.css';
import { swapDocBody, useGameState, MAX_HEIGHT, MAX_WIDTH, spoonFilter, getSpoonBalloon, getRandomInt, getAngleBetween, createDefined2DVector, spawnParticleBurst, enemyFilter, getFork } from "./util/spoonHelper";
import { createMatterEngine } from "./util/createMatterEngine";
import { GameShell } from "./util/GameShell";
import { createPausableTimerGroup } from "./util/pausableTimers";

const SpoonBalloon = () => {
  const gameKey = "spoonBalloon";
  const flavor = "if the balloon touches the ground you die (death not implemented yet).";
  const instructions = "Tap to bump balloon, hold to blow.";
  const gameState = useGameState(flavor, instructions, gameKey);
  const { canvasRef, setCanvasHeight, restartRef, setPlayButtonText,
    setGameOverState, setMessage, setScoreText, recordScore,
    gameStartedRef, rebuildKey, pauseRef, resumeRef} = gameState;
  useEffect(() => swapDocBody(), []);
  useEffect( () => {

    var isMobile = false;
    
    const width = Math.min(window.innerWidth, MAX_WIDTH);
    const height = Math.min(window.innerHeight, MAX_HEIGHT);
    setCanvasHeight(height);
    
    let Bodies = Matter.Bodies;
    let Body = Matter.Body;
    let Composite = Matter.Composite;
    let Mouse = Matter.Mouse;
    let MouseConstraint = Matter.MouseConstraint;
  
    const timers = createPausableTimerGroup();
    const { engine, runner, render, start, cleanup } = createMatterEngine(timers, canvasRef, width, height);

    const HAZARD_LABEL = "hazard";
    const PLAYER_COLOR = "silver";
    // var gameWidth = width;
    // var leftMargin = (width-gameWidth)/2;
    // var points = 0;
    var size = 100; //size var for spoon
    //mobile augmentations
    if(width < 900){
      isMobile = true;
      size = width > 500 && height > 500 ? 75 : 50;
    }

    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.2,
          render: {
            visible: false
          }
        }
      });
    
    Composite.add(engine.world, mouseConstraint);
    var player = getSpoonBalloon(size, width/2, height/2, spoonFilter, PLAYER_COLOR);
    // player.isSleeping = true;
    Composite.add(engine.world, player);
    setupBorder();
    spawnFork();

    var gameStarted = false;
    var resettable = false;
    var isMouseDown = false;
    var blowing = false;
    const maxVelocity = 5;

    Matter.Events.on(engine, 'beforeUpdate', function() {
      const g = engine.gravity;
      const gravityForce = g.y * g.scale;
      let gravCancel = gameStarted ? 0.9 : 1;
      let spoonInPlay = false;
      Composite.allBodies(engine.world)
        .forEach(body => {
          if(body.label.includes("balloon")){spoonInPlay = true}
          else{
              Body.applyForce(body, body.position, {
              x: 0,
              y: -body.mass * gravityForce 
            });
          }
        })
      if(spoonInPlay){
        Body.applyForce(player, player.position, {
          x: 0,
          y: -player.mass * gravityForce * gravCancel
        });
      }
      
      let blowForce = player.mass * gravityForce * gravCancel / 6;
      let forceVector = createDefined2DVector(blowForce, getAngleBetween(player, mouse) - Math.PI/2)
      if(blowing){
        createHand(player, "#d1d1d15a", 50);
        Body.applyForce(player, player.position, {
        x: forceVector.x,
        y: forceVector.y
      });
      }
      
      //cap velocity
      if(Math.abs(player.velocity.x) > maxVelocity || Math.abs(player.velocity.y) > maxVelocity){
        let sign = player.velocity.x >= 0 ? 1 : -1
        player.frictionAir = 0.1;
        player.velocity.x = maxVelocity*sign;
        console.log("max x hit")
      }
      else{player.frictionAir = 0.01 }

    });
    var blowingTimeout;
    Matter.Events.on(mouseConstraint, "mousedown", function(event) {
      if(!isMouseDown){
        isMouseDown = true;
        blowingTimeout = timers.setTimeout(() => {blowing = true}, 200)  
      }
    });

    Matter.Events.on(mouseConstraint, "mouseup", function(event){
      isMouseDown = false;
      if(!blowing){
        let bumpForce = isMobile ? 0.02 : 0.1; 
        let forceVector = createDefined2DVector(bumpForce, getAngleBetween(player, mouse) - Math.PI/2)
        if(gameStarted){
          applyBump(player, forceVector.x, forceVector.y);
          createHand(player);
        }
      }
      blowing = false;
      timers.clearTimeout(blowingTimeout);
    });
    
    Matter.Events.on(engine, "collisionStart", function(event) {
      event.pairs.forEach(pair => {
        collisionLogic(pair, true);
      });
    });

    function collisionLogic(pair, isStart){
      var { bodyA, bodyB } = pair;
      bodyA = bodyA.parent;
      bodyB = bodyB.parent;
      if(bodyA.label.includes("balloon")){ balloonInteraction(bodyA, bodyB)}
      else if(bodyB.label.includes("balloon")){ balloonInteraction(bodyB, bodyA)}
    }
    function balloonInteraction(balloon, otherBody){
      if(otherBody.label.includes(HAZARD_LABEL)){
        if(gameStarted){
          deathAnimation();
          gameOver()
        }
      }
    }
    function deathAnimation(){
      let count = 3 + getRandomInt(3)
      while(count >= 0){
        count--;
        spawnParticleBurst(player, PLAYER_COLOR, isMobile, engine, Composite, size/25);
      }
      Composite.remove(engine.world, player);
    }
    function applyBump(player, xForce, yForce){
      Body.applyForce(player, player.position,{
        x: xForce,
        y: yForce
      });
    }
    function createHand(player, color = "#fbd633", timeout = 400){
      let angle = getAngleBetween(player, mouse);
      const handOffset = size*3/5 

      const handX = player.position.x + Math.cos(angle) * handOffset;
      const handY = player.position.y + Math.sin(angle) * handOffset;
      let chamfer = isMobile ? 6 : 10;
      let hand = Bodies.rectangle(handX, handY - size/3,
         size*2/4, size*1/5, {isSensor: true, isStatic: true, render: {fillStyle: color}, chamfer: { radius: chamfer }});
      Body.rotate(hand, angle + Math.PI/2);
      Composite.add(engine.world, hand);
      timers.setTimeout(() => {
        Composite.remove(engine.world, hand);
      }, timeout)
    }

    function initialBump(){
      let xForce = (getRandomInt(10)-4.5)/50//cool variable name
      xForce = isMobile ? xForce/10 : xForce;
      let yForce = isMobile ? -0.015 : -0.08;
      applyBump(player, xForce, yForce)
    }
    function setupBorder(){
      //sides
      for(let i = 0; i < height/(size/5); i++){
        let spike1 = getSpike(0, i*size/2);
        let spike2 = getSpike(width, i*size/2);
        Body.rotate(spike1, Math.PI);
        Composite.add(engine.world, [spike1, spike2]);
      }
      //bottom
      for(let i = 0; i < height/(size/5); i++){
        let spike = getSpike(i*size/2, height );
        Body.rotate(spike, Math.PI/2);
        Composite.add(engine.world, spike);
      }
    }
    function getSpike(x, y){
      return Bodies.polygon(x, y, 3, size/5,
        {isSensor: true,
          isStatic: true,
          render: {fillStyle: "white"},
          label: HAZARD_LABEL,
          collisionFilter: enemyFilter
        }
      );
    }
    
    function spawnFork(){
      let fork = getFork(width/2, height/5, size, "silver", isMobile, HAZARD_LABEL, true);
      Composite.add(engine.world, fork);
    }
    
    function startGame() {
      if (gameStarted === false) {
        setGameOverState(false); // Show game over screen
        gameStarted = true;
        gameStartedRef.current = true;
        initialBump();
        // startEnemy();
      }
    }
    function restartGame(){
      if (resettable === true){
        //cleanup and reset
        resettable = false
        Composite.add(engine.world, player);
        Body.setSpeed(player, {x:0, y:0})
        Body.setVelocity(player, {x:0, y:0});
        Body.setPosition(player, {x: width/2, y: height/2})
        setScoreText(0);            // reset score
        startGame();
      }
    }
    function gameOver() {
      // setScoreText(points);
      // let endMessage = getPopupMessage()
      // setMessage(endMessage)      
      recordScore(0);  
      gameStarted = false;
      gameStartedRef.current = false;
      resettable = true;
      //set text
      //leaderboards
      timers.setTimeout(() => {
        setGameOverState(true); // Show game over screen
      }, 1100)
    }

    // function doPointIncrement(spoon, cerealPos) {
    //   //points+= 10*(spoonState.cerealHits+1);
    //   //createPlusScore(cerealPos.x, cerealPos.y, spoonState.cerealHits*10)
    // }
    // function setText() {
    //   const dropperEl = document.getElementById("dropper");
    //   //point tracking messages
    //   if(points >= 2500){
    //     if (dropperEl) dropperEl.innerHTML = "Whoa! " + points + " points";
    //   }
    //   else if(points >= 1000){
    //     if (dropperEl) dropperEl.innerHTML = "Nice! " + points + " points"; 
    //   }
    //   else{
    //     if (dropperEl) dropperEl.innerHTML = points + " points";
    //   }
    //   //if (dropperEl && debug) dropperEl.innerHTML = "Whoa! " + points + " points. Speed = " + speed;
    // }
    // function getPopupMessage(isStart){
    //   if(isStart){
    //     return "context!"
    //   }
    //   let message;
    //   if(points >= 2500){
    //     message = "great";
    //   }
    //   else message = "good";
    //   return message;
    // }
      
    function startRestart(){
      if(!gameStarted && !resettable){startGame()}
      else{
        restartGame();
      }
      setPlayButtonText("Restart")
      setMessage("")
    }
    restartRef.current = startRestart;
    pauseRef.current = () => {
      runner.enabled = false;
      timers.pauseAll();
      setScoreText("Score: ??? points")
    };
    resumeRef.current = () => {
      runner.enabled = true;
      timers.resumeAll();
    };

    start();
    setGameOverState(true); // Show game over screen
  // Cleanup on unmount
    return cleanup;
  }, [canvasRef, restartRef, setCanvasHeight, setGameOverState, setMessage, setPlayButtonText, setScoreText, recordScore, rebuildKey, gameStartedRef, pauseRef, resumeRef]);



  
  return (
    <GameShell gameName="Spoon Balloon" canvasRef={canvasRef} gameState={gameState} />
  )
  
  
};

export default SpoonBalloon;